import $ from "jquery";

const handleBackButton = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    const el = {
      button: ".js-back-button",
    };
    $(document).on("click", el.button, function (e) {
      e.preventDefault();
      history.back();
    });
  };

  init();
};

try {
  handleBackButton();
} catch (error) {
  console.error("handleBackButton", error);
}
